import { createApp } from 'vue'
import App from './App.vue'

import 'animate.css/animate.min.css'

const app = createApp(App)
import router from './router'
app.use(router)

import store from './store'
app.use(store)

import TDesign from 'tdesign-mobile-vue'
import 'tdesign-mobile-vue/es/style/index.css'
app.use(TDesign)

//挂载app
app.mount('#app')
